// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"f9816e75","453":"c9ac4fde"}[chunkId] + ".chunk.js";
};